import { Component, Input } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { PerformanceTeamOverview } from 'app/library/performance-team-review/models/performance-team-overview.model';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { TeamNavigationService } from '../../services/team-navigation.service';

@Component({
    selector: 'app-performance-team-review',
    templateUrl: './performance-team-review.component.html',
    styleUrls: ['./performance-team-review.component.scss'],
})
export class PerformanceTeamReviewComponent extends UnsubscribeOnDestroy {
    @Input()
    teamId: string;

    @Input()
    performanceTeamOverview: PerformanceTeamOverview;

    @Input()
    isPerformanceReviewTileClickable: boolean;

    constructor(private _store: Store, private _teamNavigationService: TeamNavigationService) {
        super();
    }

    openPerformanceTeamReviewPage(): void {
        this._teamNavigationService.addTeamPath(window.location.pathname);
        this._store.dispatch(new Navigate([`my-teams/team/${this.teamId}/team-reviews`]));
    }
}
